import useActionReducer from '@admin/hooks/use_action_reducer'
import RulesField from './rulesfield'
import * as actions from './actions'
import PropTypes from 'prop-types'
import reducer from './reducer'
import React from 'react'

const RulesFieldContainer = (props) => {

  const [state, handlers] = useActionReducer({
    display_name: 'rulesfield',
    actions,
    props,
    reducer
  })

  const mergedProps = {
    ...props,
    ...state,
    ...handlers
  }

  return <RulesField { ...mergedProps } />

}

RulesFieldContainer.propTypes = {}

export default RulesFieldContainer
